// extracted by mini-css-extract-plugin
export default {"allResearchWorks":"AllResearchWork_allResearchWorks__I3zCB"};